<div class="successful-credit-card-creation">
    <div class="row">
        <div class="col-4 col-pr-12 col-sm-8 col-md-10 col-lg-10 col-xl-8 offset-lg-2 ">
            <h2 class="title">
                {{ copyService.getParametrizedCopy('successful_credit_card_creation_title_credit_card', [documentInfo.firstname]) }} {{ copyService.getParametrizedCopy('successful_credit_card_creation_credit_card_amount', [amountPco]) }}
            </h2>
            <div class="wrap">
                <div class="listAndCard">
                    <div class="listBox">
                        <span id="benefitsTitle" class="benefitsTitle">{{copyService.copies.successful_credit_card_creation_sub_title_credit_card}}</span>
                        <div class="space"></div>
                        <ul>
                            <vcl-list>
                                <li *ngFor="let use of creditCardUses" vclListSimple>
                                    <span id="iconCheck" class="icon icon-itaufonts_check">
                                    </span>
                                    <vcl-list-text>
                                        {{use.description}}
                                    </vcl-list-text>
                                </li>
                            </vcl-list>
                        </ul>
                    </div>
                    <div class="cardPanel">
                        <div class="cardDetails">
                            <div class="cardText">
                                <h3 class="cardName">{{selectedProduct.label }} {{ cardType.tipo_tarjeta }} {{ copyService.copies.successful_credit_card_valid_card_name_virtual }}</h3>
                                <p class="setCreditCard">
                                    <span class="label">{{ card.product_id }}</span>
                                    <span class="description">{{ card.client_name }}</span>
                                </p>
                            </div>
                            <div class="cardImages">
                                <img id=itauImages class="image" src="assets/images/itau_rectangle.svg" alt="Itaú" />
                                <img id="visaCreditCard" class="image" src="assets/images/icon-card.svg" alt="Visa" *ngIf="selectedProduct.elementId !== 1" />
                                <img id="visaCreditCard" class="image" src="assets/images/Mastercard_preto.svg" alt="MasterCard" *ngIf="selectedProduct.elementId === 1" />
                            </div>
                        </div>
                        <div class="dateAndAmount">
                            <p id="validThru" class="setCreditCard">
                                <span class="label">{{ copyService.copies.successful_credit_card_valid_thru_text }}</span>
                                <span class="description">{{ card.expiration_date }}</span>
                            </p>
                            <p id="amount" class="setCreditCard">
                                <span class="label">{{ copyService.getParametrizedCopy('successful_credit_card_creation_credit_card_amount', [amountCard]) }}</span>
                                <span class="description">{{ copyService.copies.successful_credit_card_valid_amount }}</span>
                                <!-- Cambiar amountPCO por amountCard -->
                            </p>
                        </div>
                    </div>
                </div>
                <div class="infoBox">
                    <div class="creditCardInfo">
                        <span id="creditCardInfoText" class="creditCardInfoText">{{copyService.copies.successful_credit_card_creation_info_itau_2}}</span>
                    </div>
                    <div class="creditCardLink">
                        <p id="link" class="link">
                            {{copyService.copies.successful_credit_card_creation_info_itau}}
                            <vcl-link (click)="openLink()" [label]="copyService.copies.invitation_register_step_three_link" class="termsLink" [linkId]="'alliances'">
                            </vcl-link>
                        </p>
                        <span id="moreInfo" class="creditCardInfoText">{{copyService.copies.successful_credit_card_creation_info_itau_description}}</span>
                    </div>
                </div>
            </div>
            <!-- <div class="additionalInfoTC">
                <span id="iconCheck" class="icon icon-itaufonts_telefone additionalInfoTCIcon">
                </span>
                <p id="additionalInfoTCtext" class="additionalInfoTCtext">
                    {{ copyService.copies.successful_credit_card_creation_info_itau_phone_part_1 }}
                    <strong>{{ copyService.getParametrizedCopy('successful_credit_card_creation_info_itau_phone', [maskedPhone]) }}</strong>
                    {{ copyService.copies.successful_credit_card_creation_info_itau_phone_part_2 }}
                </p>
            </div> -->
        </div>
    </div>
</div>
<div class="container">
    <app-controls id="detailAccountCreationBtns" [nextLabel]="copyService.copies.successful_credit_card_creation_control_button" [nextDisabled]="false" (next)="next()"></app-controls>
</div>